import { FC } from 'react';
import MerchantOrTeamBlockedInfo from './MerchantOrTeamBlockedInfo';
import { ArrowRightIcon } from 'assets/icons';

interface MerchantOrTeamBlockedInfoPanelProps {
  onBack: () => void;
}

const MerchantOrTeamBlockedInfoPanel: FC<MerchantOrTeamBlockedInfoPanelProps> = ({ onBack }) => {
  return (
    <div className="w-96">
      <div className="flex items-center gap-2 py-5 px-4">
        <div onClick={onBack} className="cursor-pointer">
          <ArrowRightIcon className="rotate-180" id="blocked-info-panel-back-arrow" />
        </div>
      </div>
      <MerchantOrTeamBlockedInfo />
    </div>
  );
};

export default MerchantOrTeamBlockedInfoPanel;
